import classNames from 'classnames';
import * as React from 'react';

export interface FeatureProps extends React.HTMLAttributes<HTMLDivElement> {
    title: string;
    lead?: React.ReactNode;
    caption?: React.ReactNode;
}

export const Feature: React.FunctionComponent<FeatureProps> = ({title, lead, caption, className, children, ...rest}: FeatureProps) => (
    <div className={classNames('mp-feature', className)} {...rest}>
        {lead}
        <h3 className="mp-feature__title">{title}</h3>
        <p className="mp-feature__body">{children}</p>
        {caption}
    </div>
);
